import { gsap, Sine, Power0, Power1, Power2, Power3, Power4 } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";


document.addEventListener('DOMContentLoaded', () => {
  // 定義した処理を呼び出す（ここの中の変数はローカル）
  mySetupAjaxAction();
  // mySetupTopAjaxAction();
});
 
// 処理を関数としてまとめる
var stringToHTML = function(str) {
  var parser = new DOMParser();
  var doc = parser.parseFromString(str, 'text/html');
  return doc.body;
};
const createElmFromStr = (str) => {
  return new DOMParser().parseFromString(str, "text/html").body
    .querySelectorAll('body > div');
};

function mySetupAjaxAction() {
  const moreBtn = document.querySelector(".c-more-post");
  // const btn = document.querySelector(".js-btn-more");
  const addContainer = document.querySelector("[data-post-container]");

  if(moreBtn) {
    moreBtn.addEventListener("click", (e) => {
      const param = new URLSearchParams();

      //wp_ajax_[任意のアクション名]にて設定したAction名を指定する
      //nonceを設定
      param.append('_ajax_nonce', post_ajax_params.post_ajax_nonce);
      // カスタムデータを設定
      // param.append('name', nameInput.value);
      param.append('action', 'get_post');
      param.append('post_type', "post" );
      param.append('tag', e.target.dataset.tag );
      param.append('cat', e.target.dataset.cat );
      param.append('paged', e.target.dataset.page );
      // param.append('show_posts', '-1' );

      const xhr = new XMLHttpRequest();
      xhr.open("POST", post_ajax_params.ajaxurl);

      xhr.addEventListener('readystatechange', ()=> {
        if(xhr.readyState === 4){
          if(xhr.status >= 200 && xhr.status < 300){

            var result = JSON.parse(xhr.responseText);

            moreBtn.dataset.page = result.current_page + 1;

            if(result.current_page <= result.max_pages){
              const getElements = createElmFromStr(result.html);
              getElements.forEach(element => {
                addContainer.appendChild(element);
                element.animate(
                  [
                    { opacity: 0 },
                    { opacity: 1 }
                  ],
                  {
                    duration: 500,
                    fill: 'forwards'
                  }
                );
              });
            }
            if(result.show_button == false){
              moreBtn.closest('.c-btns').remove();
            }

          }else{
            console.log(`失敗: ${xhr.status} (${xhr.statusText})`);
          }
        }
      });
      xhr.send(param);
    });
  }

}

